module.exports = __webpack_public_path__ + "img/jpm_icons4.15a3ae61.png";